import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Signup.css';
import { API_URL } from '../utils/config';

const Signup = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { signup } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      setLoading(false);
      return;
    }

    const result = await signup(formData);
    
    if (result.success) {
      alert('Account created successfully!');
      navigate('/');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  // Google OAuth Signup - FIXED: Using backticks instead of single quotes
  const handleGoogleSignup = () => {
    // Redirect to backend Google OAuth endpoint
    window.location.href = `${API_URL}/api/auth/google`;
  };

  // Facebook OAuth Signup - FIXED: Using backticks instead of single quotes
  const handleFacebookSignup = () => {
    // Redirect to backend Facebook OAuth endpoint
    window.location.href = `${API_URL}/api/auth/facebook`;
  };

  return (
    <section id="signupsection">
      <div id="signup_container" className="container">
        {/* Google OAuth Button */}
        <button 
          onClick={handleGoogleSignup} 
          className="btng"
          type="button"
        >
          <i className="fab fa-google"></i>
          <span>Google</span>
        </button>

        {/* Facebook OAuth Button */}
        <button 
          onClick={handleFacebookSignup} 
          className="btnf"
          type="button"
        >
          <i className="fab fa-facebook-f"></i>
          <span>Facebook</span>
        </button>

        <div className="dropsingup">
          <div className="content">
            <h2>Sign Up</h2>
            
            {error && (
              <div className="error-message" style={{
                color: '#ff0f5b',
                padding: '10px',
                marginBottom: '10px',
                fontSize: '0.9em'
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="inputBox">
                <input
                  type="text"
                  placeholder="Full Name"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="inputBox">
                <input
                  type="text"
                  placeholder="Phone Number"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="inputBox">
                <input
                  type="email"
                  placeholder="Email Address"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="inputBox">
                <input
                  type="password"
                  placeholder="Password (min 6 characters)"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength="6"
                />
              </div>
              <div className="inputBox">
                <input 
                  type="submit" 
                  value={loading ? "Creating..." : "Sign Up"}
                  disabled={loading}
                />
              </div>
            </form>
          </div>
        </div>
        
        <Link to="/login" className="btns">Log In</Link>
        <a href="#" className="btns signup">Forget</a>
      </div>
    </section>
  );
};

export default Signup;